module.exports = "/_next/static/images/3f3bc6e5d053ad9feafddda0e4fc7d62-challenge-the-system-md@1x.jpg";